import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { ConfigService } from '@service/config/config.service';

@Injectable({
  providedIn: 'root'
})
export class ShopModeService
{

  public isKiosk: boolean = false;
  public isRuggo: boolean = false;
  public isRuggoChecked: boolean = false;
  public isKioskChecked: boolean = false;

  constructor(private meta: Meta, private configSercice: ConfigService) { }

  public isKioskMode(): boolean
  {
    if (this.isKioskChecked == false)
    {
      if (window.location.host.split(".").length >= 3 && window.location.host.split(".")[0].length === 3)
      {
        this.isKiosk = true;
        document.body.classList.add('kiosk-mode');
      }

      this.isKioskChecked = true;
    }

    return this.isKiosk;
  }

  public isRuggoMode(): boolean
  {
    if (this.isRuggoChecked == false)
    {
      if (window.location.host.includes("ruggo") || this.configSercice.MainDomain.includes("ruggo"))
      {
        this.isRuggo = true;
        document.body.classList.add('ruggo-mode');
      }

      this.isRuggoChecked = true;
    }

    return this.isRuggo;
  }
}
